import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { responsive } from "../../utils/responsive";

export const containerStyle = recipe({
  base: {
    padding: theme.spacings.xs,
    width: "100dvw",
    minHeight: "100dvh",
    containerType: "inline-size",
    containerName: "container",
    top: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    ...responsive({
      s: {
        padding: theme.spacings.s,
      },
      m: {
        padding: theme.spacings.m,
      },
      l: {
        padding: theme.spacings.l,
      },
    }),
  },
  variants: {
    size: {
      default: {},
      auto: {},
      small: {},
      medium: {},
      calendly: {},
      large: {},
      xl: {},
    },
    placement: {
      top: {
        position: "absolute",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
      center: {
        position: "absolute",
        justifyContent: "center",
      },
      bottom: {
        position: "absolute",
        justifyContent: "center",
        alignItems: "flex-end",
      },
    },
  },
  defaultVariants: {
    size: "default",
    placement: "top",
  },
});

export const modalStyle = style({
  // keep
});

export const modalContainerStyle = recipe({
  base: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    pointerEvents: "auto",
    borderRadius: theme.borderRadiuses.onS,
    width: "100%",
  },
  variants: {
    applyPadding: {
      true: {
        padding: "var(--padding)",
      },
    },
    padding: {
      default: {
        vars: {
          "--padding": theme.spacings.m,
        },
      },
      xs: {
        vars: {
          "--padding": theme.spacings.xs,
        },
      },
      m: {
        vars: {
          "--padding": theme.spacings.m,
        },
      },
      s: {
        vars: {
          "--padding": theme.spacings.s,
        },
      },
      none: {
        vars: {
          "--padding": "0",
        },
      },
    },
    variant: {
      default: { background: theme.colors.background },
      tint: { background: theme.colors.backgroundTint },
      tertiary: { background: theme.colors.secondary },
    },
    size: {
      default: {
        maxWidth: rem(660),
      },
      small: {
        maxWidth: rem(580),
      },
      medium: {
        maxWidth: rem(800),
      },
      auto: {
        maxWidth: rem(1600),
      },
      calendly: {
        maxWidth: rem(600),
      },
      large: {
        maxWidth: rem(1000),
      },
      xl: {
        maxWidth: rem(1200),
      },
    },
    placement: {
      top: {
        margin: "0 auto",
      },
      center: {},
      bottom: {
        margin: "0 auto",
      },
    },
    overflowHidden: {
      true: {
        overflow: "hidden",
      },
      false: {
        overflow: "visible",
      },
    },
  },
  defaultVariants: {
    padding: "default",
    variant: "default",
    size: "default",
    applyPadding: true,
    overflowHidden: true,
  },
});

export const flexStyle = recipe({
  base: {
    display: "flex",
    flexGrow: 1,
    gap: theme.spacings.m,
    flexDirection: "column",
  },
  variants: {
    overflowHidden: {
      true: {
        overflow: "hidden",
      },
      false: {
        overflow: "visible",
      },
    },
  },
  defaultVariants: {
    overflowHidden: true,
  },
});

export const titleStyle = recipe({
  base: {},
  variants: {
    withClose: {
      true: {
        minHeight: rem(48),
      },
    },
  },
});

export const closeStyle = recipe({
  base: {
    position: "absolute",
    zIndex: 3,
  },
  variants: {
    padding: {
      default: {
        top: theme.spacings.s,
        right: theme.spacings.s,
      },
      parent: {
        top: "var(--padding)",
        right: "var(--padding)",
      },
    },
  },
  defaultVariants: {
    padding: "parent",
  },
});
